import { joiResolver } from '@hookform/resolvers/joi';
import { Alert } from 'components/atoms/Alert';
import { Button } from 'components/atoms/Button';
import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import type { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AccountTypeEnum, type IUser } from 'types/users.types';
import {
  getIsEuro6ebisApplicable,
  VehicleFormValidationSchema,
} from './helpers';
import VehicleFormFields from './VehicleFields';

const VehicleForm: FC<any> = ({ defaultValues, onSubmit }) => {
  const { t } = useTranslation();
  const formApi = useForm({
    defaultValues,
    resolver: (values, context, ...args) =>
      joiResolver(VehicleFormValidationSchema, {
        allowUnknown: true,
        abortEarly: false,
      })(
        values,
        {
          ...context,
          isEuro6ebisApplicable: getIsEuro6ebisApplicable(values),
        },
        ...args,
      ),
  });
  //
  const isEdit = !!defaultValues?._id;

  const customer = useGetCurrentCustomerData().data as IUser;

  return (
    <FormProvider {...formApi}>
      <div className="bg-[#f6f6fd] px-8 py-10 rounded-t-2xl">
        <p className="text-primary-900 text-lg leading-tight">
          {t(
            'expense.we_need_some_information_about_your_vehicle_to_compute_your_income_tax_properly',
          )}
        </p>
        <p className="text-primary-700 leading-tight mt-4">
          {t('expense.be_cars_form.subtitle', {
            taxType: t(
              customer?.accountType === AccountTypeEnum.one_person_company
                ? 'expenses.helper.car_deductibility.corporate_tax'
                : 'expenses.helper.car_deductibility.Income_tax',
            ).toLowerCase(),
          })}
        </p>
      </div>
      <div className="px-8 py-4">
        {isEdit && (
          <Alert
            type="warning"
            description={t('vehicle.modifications_warning')}
          />
        )}
        <VehicleFormFields className="flex flex-col gap-4" />
        <Button
          loading={formApi.formState.isSubmitting}
          className="mt-6 mb-4 w-full"
          onClick={formApi.handleSubmit(onSubmit)}
        >
          {t('save')}
        </Button>
      </div>
    </FormProvider>
  );
};

export default VehicleForm;
